import api, { adminApiPrefix } from './Api';
import {
  AffiliateUserFilter,
  affiliateUserFilterToQueryParams,
} from '../interfaces/AffiliateUserSummary/AffiliateUserFilter';
import { PaginatedResponse } from '../interfaces/PaginatedResponse';
import {
  AffiliateUserSummary,
  affiliateUserSummaryFromResponse,
} from '../interfaces/AffiliateUserSummary/AffiliateUserSummary';

const affiliateAdminApiPrefix = `${adminApiPrefix}/affiliate`;

export const getAffiliateUserSummaries = async (
  filter: AffiliateUserFilter,
): Promise<PaginatedResponse<AffiliateUserSummary>> => {
  const response = await api.get(affiliateAdminApiPrefix, {
    params: affiliateUserFilterToQueryParams(filter),
  });

  return {
    data: (response.data?.data ?? []).map(affiliateUserSummaryFromResponse),
    totalCount: response.data?.total_count ?? 0,
  };
};

export const getAffiliateUser = async (
  id: number,
): Promise<AffiliateUserSummary> => {
  const response = await api.get(`${affiliateAdminApiPrefix}/${id}`);

  return affiliateUserSummaryFromResponse(response.data?.data);
};
